import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'
import Icon from 'components/Icon'
import Currency from 'components/Pricing/components/Currency'
import Tag from 'components/Tag'
import Typography from 'components/Typography'
import { mapPricingCategories, getPricingTexts } from 'helpers/dataTransformers/pricing'
import { priceFormatter } from 'helpers/formatters'
import useViewport from 'hooks/useViewport'

import classes from './Amount.module.scss'

/** @type {import("./types").default} */
const Amount = ({ pricing, className, ...props }) => {
  const { is } = useViewport()
  const { periodicityText, pricingModelText } = getPricingTexts(pricing)
  const { hasFreeTrial, isFree } = mapPricingCategories(pricing?.categories)

  return (
    <Grid className={clsx('Amount', classes.root, className)} {...props}>
      <div className={classes.amount}>
        <Currency pricing={pricing} />

        <Typography component="span" className={classes.number}>
          {priceFormatter(pricing?.amount)}
        </Typography>

        <Typography variant="tight-xxs" component="span">
          {pricingModelText}
          {periodicityText ? ' /' : ''}
          {!is('xs') && <br />}
          {periodicityText}
        </Typography>
      </div>
      <div className={classes.tags}>
        <Tag className={classes.tag} size="tiny" color={hasFreeTrial ? 'teal' : 'grey'} disableRipple>
          Free trial
          <Icon icon={hasFreeTrial ? 'check' : 'times'} size="12" />
        </Tag>
        <Tag className={classes.tag} size="tiny" color={isFree ? 'teal' : 'grey'} disableRipple>
          Free version
          <Icon icon={isFree ? 'check' : 'times'} size="12" />
        </Tag>
      </div>
    </Grid>
  )
}

export default Amount
